import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import HeaderCustom from "../../../components/HeaderCustom";
import SkeletonLoading from "../../../components/SkeletonLoading";
import "../../../styles/AppCss.css";
import { useParams, useSearchParams, useNavigate } from "react-router-dom";
import { getBuscarCategoria, getCategorias, getDetalleLocal, postAddLocal, postUpdateLocal } from "../../../api/ApiService";
import AddLocalComponents from "./components/AddLocalComponents";

function AddLocalPage() {
    const [cargando, setCargando] = useState(false);
    const [razonSocial, setRazonSocial] = useState("");
    const [ubicacion, setUbicacion] = useState("");
    const [descripcion, setDescripcion] = useState("");
    const [ruc, setRuc] = useState("");
    const [nombreFantasia, setNombreFantasia] = useState("");
    const [cantidadPersonasEnLocal, setCantidadPersonasEnLocal] = useState("");
    const [telefono, setTelefono] = useState("");
    const [isTelefonoWhatsapp, setIsTelefonoWhatsapp] = useState(false);
    const [isParticipaGiftCard, setIsParticipaGiftCard] = useState(false);
    const [categorias, setCategorias] = useState([]);
    const [categoriaSelected, setCategoriaSelected] = useState(null);

    const [imagen, setImagen] = useState("");
    const [imagenFormData, setImagenFormData] = useState("");
    const [open, setOpen] = useState(false);
    const [severity, setSeverity] = useState("");
    const [mensaje, setMensaje] = useState("");
    const [loadingGuardar, setLoadingGuardar] = useState(false);
    const [categoriaQuery, setCategoriaQuery] = useState("");

    const stateToken = useSelector((state) => state.reducerGlobal.token);

    const { id } = useParams();
    const [searchParams] = useSearchParams();

    const mode = searchParams.get('mode');

    console.log("id", id);
    console.log("searchParams", mode);

    const navigate = useNavigate();

    useEffect(() => {
        //poner el scroll al top
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        if (id) {
            if (stateToken) {
                handleDetalleLocal();
                handleListarCategorias();
            }
        } else {

            if (stateToken) {
                handleListarCategorias();
            }
        }

    }, [id, stateToken]);


    useEffect(() => {
        const timeOutId = setTimeout(() => {
            if (categoriaQuery.length > 2) {

                handleFiltrarCategorias();
            }
        }, 1500);
        return () => clearTimeout(timeOutId);
    }, [stateToken, categoriaQuery]);




    const handleListarCategorias = () => {
        let body = {
            page: "",
            per_page: "",
            titulo: "",
        };
        getCategorias(stateToken?.access_token, body)
            .then((response) => {
                setCargando(true);
                if (response?.data?.length > 0) {
                    setCategorias(response?.data);
                }
            })
            .catch(() => {
                setCargando(true);
                setLoadingGuardar(false);
                setOpen(true);
                setSeverity("error");
                setMensaje("Error al cargar las categorias");

            });
    };


    const handleFiltrarCategorias = () => {
        let body = {
            page: "",
            per_page: "",
            titulo: categoriaQuery,
        };
        getBuscarCategoria(stateToken?.access_token, body)
            .then((response) => {
                // console.log("getCategorias", response);

                setCargando(true);
                if (response?.data?.data?.length > 0) {
                    setCategorias(response?.data?.data || []);
                }
            })
            .catch(() => {
                setLoadingGuardar(false);
                setOpen(true);
                setSeverity("error");
                setMensaje("Error al cargar las categorias");
                setTimeout(() => {
                    setOpen(false);
                }, 2000);
            });
    };

    const handleDetalleLocal = () => {
        getDetalleLocal(id, stateToken?.access_token)
            .then((response) => {
                setCargando(true);
                setRazonSocial(response?.data?.razon_social || "");
                setRuc(response?.data?.ruc || "");
                setNombreFantasia(response?.data?.nombre_fantasia || "");
                setTelefono(response?.data?.telefono || "");
                setCantidadPersonasEnLocal(response?.data?.cantidad_maxima || "");
                setIsTelefonoWhatsapp(response?.data?.whatsapp === "1");
                setIsParticipaGiftCard(response?.data?.participa_giftcard === "1");
                setImagen(response?.data?.thumbnail || "");
                setUbicacion(response?.data?.ubicacion || "");
                setDescripcion(response?.data?.descripcion || "");

                let body = {
                    page: "",
                    per_page: "",
                    titulo: response?.data?.categoria?.nombre || "",
                };
                // getCategorias(stateToken?.access_token, body)
                getBuscarCategoria(stateToken?.access_token, body)
                    .then((responseCategoria) => {
                        // console.log("responseCategoria", responseCategoria?.data);
                        if (responseCategoria?.data?.data?.length > 0) {
                            const categoriaAux = responseCategoria?.data?.data?.filter(
                                (item) => item.id === Number(response?.data?.id_categoria)
                            );
                            // console.log("categoriaAux", categoriaAux);
                            if (categoriaAux.length > 0) {
                                setCategoriaSelected(categoriaAux[0]);
                                // setCategoriaQuery(categoriaAux[0].nombre);
                            }
                        }
                    })
                    .catch(() => { });
            })
            .catch(() => {
                setCargando(true);
                setLoadingGuardar(false);
                setMensaje("Error al cargar los datos");
                setSeverity("error");
                setOpen(true);
            });
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleCancelar = () => {
        window.history.back();
    };

    const validateFields = () => {
        if (razonSocial.trim() === "") {
            setOpen(true);
            setSeverity("warning");
            setMensaje("El campo razon social es obligatorio");
            return false;
        }
        if (ruc.trim() === "") {
            setOpen(true);
            setSeverity("warning");
            setMensaje("El campo ruc es obligatorio");
            return false;
        }
        if (nombreFantasia.trim() === "") {
            setOpen(true);
            setSeverity("warning");
            setMensaje("El campo nombre fantasia es obligatorio");
            return false;
        }
        if (categoriaSelected === null) {
            setOpen(true);
            setSeverity("warning");
            setMensaje("El campo categoria es obligatorio");
            return false;
        }
        if (imagen === "") {
            setOpen(true);
            setSeverity("warning");
            setMensaje("El campo imagen es obligatorio");
            return false;
        }
        if (ubicacion.trim() === "") {
            setOpen(true);
            setSeverity("warning");
            setMensaje("El campo ubicacion es obligatorio");
            return false;
        }
        if (cantidadPersonasEnLocal.trim() === "") {
            setOpen(true);
            setSeverity("warning");
            setMensaje("El campo cantidad de personas en local es obligatorio");
            return false;
        }
        if (telefono.trim() === "") {
            setOpen(true);
            setSeverity("warning");
            setMensaje("El campo telefono es obligatorio");
            return false;
        }
        if (descripcion.trim() === "") {
            setOpen(true);
            setSeverity("warning");
            setMensaje("El campo descripcion es obligatorio");
            return false;
        }
        return true;
    };

    const buildFormData = () => {
        const formData = new FormData();
        formData.append("razon_social", razonSocial);
        formData.append("ruc", ruc);
        formData.append("nombre_fantasia", nombreFantasia);
        formData.append("categoria_id", categoriaSelected?.id);
        formData.append("ubicacion", ubicacion);
        formData.append("telefono", telefono);
        formData.append("cantidad_maxima_persona_local", cantidadPersonasEnLocal);
        formData.append("telefono_con_whatsapp", isTelefonoWhatsapp ? 1 : 0);
        formData.append("participa_giftcard", isParticipaGiftCard ? 1 : 0);
        formData.append("descripcion", descripcion);
        formData.append("imagen", imagenFormData);
        return formData;
    };

    const handleGuardar = () => {
        if (!validateFields()) {
            return;
        }

        setLoadingGuardar(true);
        handleAddLocalApi(buildFormData());
    };

    const handleAddLocalApi = (body) => {
        postAddLocal(body, stateToken?.access_token)
            .then(() => {
                setLoadingGuardar(false);
                setOpen(true);
                setSeverity("success");
                setMensaje("Guardado con exito");
                setTimeout(() => {
                    navigate('/app/admin/locales');
                }, 1500);

                //limpiar campos
                setRazonSocial("");
                setRuc("");
                setNombreFantasia("");
                setTelefono("");
                setCantidadPersonasEnLocal("");
                setIsTelefonoWhatsapp(false);
                setIsParticipaGiftCard(false);
                setImagen("");
                setUbicacion("");
                setDescripcion("");
                setCategoriaSelected(null);
            })
            .catch(() => {
                setLoadingGuardar(false);
                setOpen(true);
                setSeverity("error");
                setMensaje("Error al guardar el local");
                setTimeout(() => {
                    setOpen(false);
                }, 2000);
            });
    };

    const handleUpdate = () => {
        if (!validateFields()) {
            return;
        }

        setLoadingGuardar(true);
        handleUpdateLocalApi(buildFormData());
    };

    const handleUpdateLocalApi = (body) => {
        postUpdateLocal(body, id, stateToken?.access_token)
            .then(() => {
                setLoadingGuardar(false);
                setTimeout(() => {
                    setOpen(true);
                    setSeverity("success");
                    setMensaje("Actualizado con exito");
                    setTimeout(() => {
                        navigate('/app/admin/locales');
                    }, 1500);
                }, 1000);
            })
            .catch(() => {
                setLoadingGuardar(false);
                setOpen(true);
                setSeverity("error");
                setMensaje("Error al guardar el local");
                setTimeout(() => {
                    setOpen(false);
                }, 2000);
            });
    };

    const handleAgregarImagen = (event) => {
        const file = event.target.files[0];

        if (file) {
            const reader = new FileReader();
            reader.onload = (e) => {
                const img = new Image();
                img.onload = () => {
                    if (img.width === 720 && img.height === 720) {
                        setImagen(e.target.result);
                        setImagenFormData(file);
                    } else {
                        setOpen(true);
                        setSeverity("error");
                        setMensaje("La imagen debe tener dimensiones 720x720 píxeles");
                    }
                };
                img.src = e.target.result;
            };
            reader.readAsDataURL(file);
        }
    };

    const handleCategoriaSelected = (value) => {
        setCategoriaSelected(value);
    };


    return (
        <HeaderCustom>
            <div className="min-h-screen bg-gray-100 p-4 sm:p-6">
                <div className="mx-auto max-w-6xl">
                    <div className="mb-6">
                        <h1 className="mb-1 text-2xl font-bold text-gray-800">
                            {/* {id ? "Actualizar Local" : "Crear Local"} */}
                            {id ? (mode === "view" ? "Detalle Local" : "Actualizar Local") : "Crear Local"}
                        </h1>
                        <p className="text-sm text-gray-500">
                            {id ? (mode === "view" ? "Visualiza la información del local." : "Actualiza la información del local.") : "Carga la imagen y completa la información principal del local."}
                        </p>
                    </div>

                    {cargando ? (
                        <AddLocalComponents
                            id={id}
                            mode={mode}
                            razonSocial={razonSocial}
                            setRazonSocial={setRazonSocial}
                            ruc={ruc}
                            setRuc={setRuc}
                            nombreFantasia={nombreFantasia}
                            setNombreFantasia={setNombreFantasia}
                            cantidadPersonasEnLocal={cantidadPersonasEnLocal}
                            setCantidadPersonasEnLocal={setCantidadPersonasEnLocal}
                            telefono={telefono}
                            setTelefono={setTelefono}
                            isTelefonoWhatsapp={isTelefonoWhatsapp}
                            setIsTelefonoWhatsapp={setIsTelefonoWhatsapp}
                            isParticipaGiftCard={isParticipaGiftCard}
                            setIsParticipaGiftCard={setIsParticipaGiftCard}
                            categorias={categorias}
                            ubicacion={ubicacion}
                            setUbicacion={setUbicacion}
                            descripcion={descripcion}
                            setDescripcion={setDescripcion}
                            handleCategoriaSelected={handleCategoriaSelected}
                            categoriaSelected={categoriaSelected}
                            imagen={imagen}
                            setImagen={setImagen}
                            handleCancelar={handleCancelar}
                            handleGuardar={handleGuardar}
                            handleUpdate={handleUpdate}
                            handleAgregarImagen={handleAgregarImagen}

                            setCategoriaQuery={setCategoriaQuery}
                            categoriaQuery={categoriaQuery}
                        />
                    ) : (
                        <div className="bg-white rounded-xl shadow-md p-8">
                            <div className="h-6 bg-gray-200 rounded w-1/3 mb-6 animate-pulse" />
                            <div className="space-y-4">
                                <div className="h-10 bg-gray-200 rounded animate-pulse" />
                                <div className="h-10 bg-gray-200 rounded animate-pulse" />
                                <div className="h-24 bg-gray-200 rounded animate-pulse" />
                            </div>
                        </div>
                    )}
                </div>
            </div>

            {loadingGuardar && (
                <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-slate-900/35 backdrop-blur-sm">
                    <div className="flex items-center gap-3 rounded-xl bg-white px-5 py-4 shadow-xl">
                        <div className="h-5 w-5 animate-spin rounded-full border-2 border-[#104063] border-t-transparent" />
                        <p className="text-sm font-medium text-gray-700">Guardando local...</p>
                    </div>
                </div>
            )}

            {open && (
                <div className="fixed right-4 top-4 z-[10000] max-w-sm">
                    <div
                        className={`rounded-xl border px-4 py-3 shadow-lg ${severity === "success"
                            ? "border-emerald-200 bg-emerald-50 text-emerald-700"
                            : severity === "warning"
                                ? "border-amber-200 bg-amber-50 text-amber-700"
                                : "border-red-200 bg-red-50 text-red-700"
                            }`}
                    >
                        <div className="flex items-start justify-between gap-4">
                            <p className="text-sm font-medium">{mensaje}</p>
                            <button
                                type="button"
                                onClick={handleClose}
                                className="text-current opacity-70 transition-opacity hover:opacity-100"
                            >
                                ×
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </HeaderCustom>
    );
}

export default AddLocalPage;
